import { getFacebookClickParameter } from '@utils/facebook';
import cookie from 'js-cookie';

import { Config } from '@providers/ConfigRedirectProvider';
import { filterFalsyValues, getParamByKey } from './common';

export const getReferrer = () => {
  let referer: any = null;

  try {
    const refererUrl = new URL(document.referrer);

    if (refererUrl.host !== document.location.host) {
      localStorage.setItem('_ref', refererUrl.toString());
    }
  } catch (e) { }

  referer = localStorage.getItem('_ref');

  return referer;
};

const buildEventSourceUrl = (config: Config): string => {
  const origin = window.location.origin

  const configId = sessionStorage.getItem('mytraits_config_id') ?? ''

  if (!configId) {
    return window.location.href
  }

  const url = new URL(`${origin}/${configId}`)

  Object.entries(config.params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value))
    }
  })

  return url.toString()
}

export const getAttribution = ({
  ip,
  country,
  config
}: {
  ip: string;
  country: string;
  config: Config;
}) => {
  const userAgent = navigator.userAgent ?? ''
  const userAgent_1 = userAgent.slice(0, 100)
  const userAgent_2 = userAgent.slice(100, 200)
  const userAgent_3 = userAgent.slice(200, 300)
  const userAgent_4 = userAgent.slice(300, 400)

  return filterFalsyValues({
    project: import.meta.env.VITE_SUBSCRIPTION_BUNDLE,
    campaign_id: getParamByKey('campaign_id') ?? config?.params.campaign_id,
    campaign_name: getParamByKey('campaign_name') ?? config?.params.campaign_name,
    adset_id: getParamByKey('adset_id') ?? config?.params.adset_id,
    adset_name: getParamByKey('adset_name') ?? config?.params.adset_name,
    ad_id: getParamByKey('ad_id') ?? config?.params.ad_id,
    media_source: getParamByKey('media_source') ?? config?.params.media_source,
    config: getParamByKey('config') ?? sessionStorage.getItem('mytraits_config_id'),
    country_code: country || '',
    ad_name: getParamByKey('ad_name') ?? config?.params.ad_name,
    fbc: cookie.get('_fbc') ?? getFacebookClickParameter()._fbc,
    fbp: getParamByKey('_fbp') ?? config?.params._fbp ?? getFacebookClickParameter()._fbp,
    fb_pixel: getParamByKey('fb') ?? config?.params.fb,
    referer: getReferrer(),
    event_source_url: buildEventSourceUrl(config),
    client_user_agent: navigator.userAgent,
    client_ip_address: ip,
    idfm: new URLSearchParams(window.location.search).get('_idfm') ?? config?.params._idfm ?? localStorage.getItem('@RNMV/IDFM'),
    userAgent_1,
    userAgent_2,
    userAgent_3,
    userAgent_4,
  })
}

export function convertStringToBoolean(incomeString: string) {
  switch (incomeString.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true;
    case 'false':
    case 'no':
    case '0':
    case null:
      return false;
    default:
      return false;
  }
}
